export const HOME_DELIVERY = 'home';
export const DEALER_DELIVERY = 'dealer';
